import React from 'react';
import styled from '@emotion/styled';
import Avatar from '@atlaskit/avatar';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const NegativeMargin = styled.div({
  margin: "var(--ds-space-negative-025, -2px)",
  display: 'flex'
});
export const ResultAvatar = props => /*#__PURE__*/React.createElement(NegativeMargin, null, /*#__PURE__*/React.createElement(Avatar, props));